// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__37Y7r","header":"ReportDetails_header__EUcIb","title":"ReportDetails_title__1iwae","left":"ReportDetails_left__2W-nY"};